<script lang="ts">
import GenericButton from "@/Components/Generics/GenericButton.vue";
import Plane from "@/Components/Generics/Plane.vue";
import MainPage from "@/Components/MainPage.vue";
import BreezeValidationErrors from "@/Components/ValidationErrors.vue";
import App from "@/Layouts/App.vue";
import { defineComponent } from "vue";

export default defineComponent({
    name: "ForgotPasswordVue",
    components: {
        MainPage,
        Plane,
        GenericButton,

        BreezeValidationErrors,
    },
    layout: App,

    props: {
        status: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                email: "",
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.route("password.email"));
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('auth.password_reset')" :gap="false">
        <Plane class="login-plane" :darker="true">
            <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                <div class="text text--primary-b text--size-18 text--medium text--height-22 text--center">
                    {{ $trans("auth.forgot_password_text") }}
                </div>

                <BreezeValidationErrors />

                <div v-if="status" class="text text--accent-gray-b text--size-16 text--semi-bold text--center">
                    {{ status }}
                </div>

                <form class="full-width" @submit.prevent="submit">
                    <div class="flex flex--v flex--gap-20">
                        <div class="flex flex--v flex--gap-5">
                            <label for="email" class="form-label">{{ $trans("auth.email") }}</label>
                            <input id="email" v-model="form.email" name="email" type="email" class="form-control" required autofocus autocomplete="username" />
                        </div>

                        <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                            <GenericButton class="login-button" :title="$trans('auth.password_reset')" :disabled="form.processing" @click="submit" />

                            <div class="flex flex--v flex--valign-c flex--gap-10">
                                <InertiaLink :href="route('login')" class="inertia-link text text--less-gap text--primary-b text--size-16 text--center">{{ $trans("auth.login") }}</InertiaLink>
                                <InertiaLink :href="route('register')" class="inertia-link text text--less-gap text--primary-b text--size-16 text--center">{{ $trans("auth.register") }}</InertiaLink>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </Plane>
    </MainPage>
</template>

<style lang="scss" scoped>
.login-plane {
    max-width: rem(500);
    margin: 0 auto;

    .login-button {
        height: rem(45);
        margin-top: rem(5);
    }

    .inertia-link {
        &:hover {
            text-decoration: underline;
        }
    }
}

.form-check label {
    line-height: 1.5em;
}
</style>
